import EventDetailStandings from '@/screens/EventDetailStandings';

export default function PrivateTabsEventEventIdStandingsRoute() {
  return <EventDetailStandings />;
}
